import { BORDER_COLOR, SKIP_BUTTON_BACKGROUND_COLOR, SKIP_BUTTON_TEXT_COLOR } from "../../theme";

export const styles = {
    headingContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        alignContent: "center",
        flexWrap: "wrap",
        marginBottom: "30px",
        gap: "10px"
    } as const,
    addMembersContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    } as const,
    button: {
        borderRadius: "var(--radius-md, 8px)",
        border:
            "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
        background: SKIP_BUTTON_BACKGROUND_COLOR,
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        color: SKIP_BUTTON_TEXT_COLOR,
        textTransform: "none",
        width: "200px"
    } as const,
    addMemberButton: {
        color: "white",
        backgroundColor: "#1F242F"
    } as const,
    personAddAltIcon: {
        color: "white",
        fontSize: "22px",
        marginRight: "5px",
        marginTop: -0.5
    } as const,
    scrollContainer: {
        border: "1px solid #26292B",
        marginTop: "20px",
        borderRadius: "var(--radius-xl, 12px)",
        maxHeight: "calc(100vh - 165px)",
        height: "auto",
        overflowY: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    } as const,
    breadcrumbsButton: {
        color: "white",
        width: "auto",
        fontSize: "14px",
        fontWeight: 400,
        backgroundColor: "#1F242F",
        padding: "var(--spacing- xs, 4px) var(--spacing - md, 8px)"
    } as const,
    th: {
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
        background: "var(--Colors-Background-bg-secondary, #161B26)",
    } as const,
    nameContainer: {
        width: "50%",
        display: "flex",
        alignItems: "center",
        paddingLeft: "10px",
    } as const,
    otherDetails: {
        width: "50%",
        display: "flex",
        alignItems: "center",
    } as const,
    tableRow: {
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
        borderBottom: `1px solid ${BORDER_COLOR}`
    } as const,
    avatarAndNameContainer: {
        width: "50%",
        display: "flex",
        alignItems: "center",
        paddingLeft: "10px",
    } as const,
    otherDetailsContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "20vh",
    } as const,
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "20vh",
    } as const,
    roleContainer: {
        minWidth: "70px",
        display: "flex",
        alignItems: "center",
    } as const,
    dAddedContainer: {
        minWidth: "70px",
        display: "flex",
        alignItems: "center",
    } as const,
    lastActiveContainer: {
        minWidth: "70px",
        display: "flex",
        alignItems: "center",
    } as const,
    controlsContainer: {
        width: "80px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    } as const,
    emptySpace: {
        width: "100%",
    } as const
}